import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import Helper from './helper';

import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        // this.initStickyNavbar();

        this.initNavbarBackdrop();
        this.photoSlider();
        this.cardSlider();
        this.cookies();
        this.scrollIntoView();
    }

    initNavbarBackdrop() {
        const collapseEl = document.getElementById('main-navbar-collapse');

        if (!collapseEl) return;

        // Create backdrop element
        const backdrop = document.createElement('div');
        backdrop.classList.add('main-navbar__backdrop');
        document.body.appendChild(backdrop);

        collapseEl.addEventListener('show.bs.collapse', () => {
            backdrop.classList.add('main-navbar__backdrop--visible');
        });

        collapseEl.addEventListener('hide.bs.collapse', () => {
            backdrop.classList.remove('main-navbar__backdrop--visible');
        });

        // Close menu when backdrop is clicked
        backdrop.addEventListener('click', () => {
            bootstrap.Collapse.getInstance(collapseEl)?.hide();
        });
    }

    initStickyNavbar() {
        const navbar = document.getElementById('main-navbar');

        const header = document.querySelector('header');

        if (navbar === null || header == null) {
            return false;
        }

        const scrolled = navbar.offsetHeight;

        const sticky = header.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= scrolled) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }

            if (window.pageYOffset >= sticky) {
                navbar.classList.add('sticky');
            } else {
                navbar.classList.remove('sticky');
            }
        });
    }

    photoSlider() {
        document.querySelectorAll('.card__photos-list').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                autoplay: false,
                loop: true,
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,
                navigation: {
                    prevEl: element.closest('section').querySelector('.card__photos-nav-button--prev'),
                    nextEl: element.closest('section').querySelector('.card__photos-nav-button--next')
                }
            });
        });
    }

    cardSlider() {
        document.querySelectorAll('.card-slider__list').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                autoplay: true,
                loop: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1
                    },
                    576: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3
                    },
                    1200: {
                        slidesPerView: 'auto'
                    }
                },
                navigation: {
                    prevEl: element.closest('section').querySelector('.card-slider__nav-button--prev'),
                    nextEl: element.closest('section').querySelector('.card-slider__nav-button--next')
                },
                spaceBetween: 20,
                slidesPerGroup: 1
            });
        });
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    scrollIntoView() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                const targetId = this.getAttribute('href').slice(1); // remove the #

                const target = document.getElementById(targetId);

                if (target) {
                    e.preventDefault();

                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        });

        const buttonScroll = document.getElementById('scroll-down');

        if (buttonScroll) {
            buttonScroll.addEventListener('click', function (e) {
                e.preventDefault();

                let target = document.querySelector('section:first-of-type');

                if (target === null) {
                    target = document.querySelector('footer');
                }

                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.scrollY,
                    behavior: 'smooth'
                });
            });
        }
    }
}

window.addEventListener('load', () => new App());
